<p-card class="plan-card" [class.current-plan]="isCurrent">
  <ng-template #title>
    <div class="plan-title">
      <span>{{ plan.name || unnamedPlanLabel }}</span>
      @if (isCurrent) {
        <p-badge [value]="currentBadgeLabel" severity="success" />
      }
    </div>
  </ng-template>
  <ng-template #subtitle>{{ plan.description || noDescriptionLabel }}</ng-template>

  <div class="plan-price">
    <span class="price-amount">
      {{ currencySymbol }}{{ (plan.amount_cents || 0) / 100 }}
    </span>
    <span class="price-currency">{{ plan.amount_currency || 'USD' }}</span>
    <span class="price-interval">/ {{ plan.interval || intervalMonthLabel }}</span>
  </div>

  @if (plan.charges && plan.charges.length > 0) {
    <div class="plan-charges">
      @if (graduatedCharges.length > 0) {
        <h4 i18n="@@planCard.usageBased">Usage-based pricing:</h4>
        @for (charge of graduatedCharges; track charge.lago_id) {
          <div class="charge-item">
            <div class="charge-metric">
              <strong>{{ charge.billable_metric_code }}</strong>
            </div>
            <div class="graduated-ranges">
              @for (range of charge.properties?.graduated_ranges ?? []; track $index) {
                <div class="range-item">
                  <span class="range-value">
                    {{ range.from_value }}
                    @if (range.to_value !== null) {
                      - {{ range.to_value }}
                    } @else {
                      +
                    }
                  </span>
                  <span class="range-pricing">
                    @if (range.flat_amount && range.flat_amount !== '0') {
                      <span>{{ currencySymbol }}{{ range.flat_amount }} <ng-container i18n="@@planCard.flat">flat</ng-container></span>
                    }
                    @if (range.per_unit_amount && range.per_unit_amount !== '0') {
                      <span>{{ currencySymbol }}{{ range.per_unit_amount }}/<ng-container i18n="@@planCard.unit">unit</ng-container></span>
                    }
                  </span>
                </div>
              }
            </div>
          </div>
        }
      }

      @if (dynamicCharges.length > 0) {
        <p-accordion styleClass="additional-charges-accordion">
          <p-accordion-panel value="0">
            <p-accordion-header>
              <div class="accordion-header">
                <span i18n="@@planCard.additionalCharges">Additional Charges</span>
                <i class="pi pi-info-circle"
                   i18n-pTooltip="@@planCard.dynamicPricingNotice"
                   pTooltip="Price is determined by usage based on selected model parameters"
                   tooltipPosition="top"></i>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <p class="dynamic-pricing-notice" i18n="@@planCard.dynamicPricingNotice">Price is determined by usage based on selected model parameters</p>
              <div class="dynamic-metrics">
                @for (charge of dynamicCharges; track charge.lago_id) {
                  <span class="metric-badge">{{ charge.billable_metric_code }}</span>
                }
              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      }
    </div>
  }

  <ng-template #footer>
    <div class="plan-footer">
      <div class="footer-left">
        @if (isCurrent && plan.code !== defaultPlanCode) {
          <p-button
            i18n-label="@@common.cancel"
            label="Cancel"
            (onClick)="onCancelClick()"
            severity="secondary"
            [outlined]="true"
            [loading]="isLoading"
          />
        }
      </div>
      <div class="footer-right">
        @if (isCurrent) {
          <p-button
            i18n-label="@@planCard.currentPlan"
            label="Current Plan"
            [disabled]="true"
          />
        } @else {
          <p-button
            i18n-label="@@planCard.subscribe"
            label="Subscribe"
            (onClick)="onSubscribeClick()"
            severity="primary"
            [loading]="isLoading"
          />
        }
      </div>
    </div>
  </ng-template>
</p-card>
